/* eslint-disable */

if (!Array.prototype.reduce) {
    Array.prototype.reduce = function (callback /*, initialValue*/) {
        'use strict';
        if (this === null) {
            throw new TypeError('Array.prototype.reduce called on null or undefined');
        }
        if (typeof callback !== 'function') {
            throw new TypeError(callback + ' is not a function');
        }
        var t = Object(this), len = t.length >>> 0, k = 0, value;
        if (arguments.length >= 2) {
            value = arguments[1];
        } else {
            while (k < len && !(k in t)) {
                k++;
            }
            if (k >= len) {
                throw new TypeError('Reduce of empty array with no initial value');
            }
            value = t[k++];
        }
        for (; k < len; k++) {
            if (k in t) {
                value = callback(value, t[k], k, t);
            }
        }
        return value;
    };
}

if (!Object.keys) {
    Object.keys = (function () {
        var hasOwnProperty = Object.prototype.hasOwnProperty,
            hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'),
            dontEnums = [
                'toString',
                'toLocaleString',
                'valueOf',
                'hasOwnProperty',
                'isPrototypeOf',
                'propertyIsEnumerable',
                'constructor'
            ],
            dontEnumsLength = dontEnums.length;

        return function (obj) {
            if (typeof obj !== 'object' && typeof obj !== 'function' || obj === null) throw new TypeError('Object.keys called on non-object');

            var result = [];

            for (var prop in obj) {
                if (hasOwnProperty.call(obj, prop)) result.push(prop);
            }

            if (hasDontEnumBug) {
                for (var i = 0; i < dontEnumsLength; i++) {
                    if (hasOwnProperty.call(obj, dontEnums[i])) result.push(dontEnums[i]);
                }
            }
            return result;
        }
    })()
};
Number.isInteger = Number.isInteger || function (value) {
    return typeof value === 'number' &&
        isFinite(value) &&
        Math.floor(value) === value;
};
if(typeof Map === 'undefined') {
    var isArray = function(array) {
        return Object.prototype.toString.call(array) === '[object Array]'
    }
    var eIndexOf = function (key) {
        if(key !== key) {
            for(var i = 0; i < this.length; i++) {
                if(this[i] !== this[i]) {
                    return i;
                }
            }
            return -1;
        } else {
            return this.indexOf(key);
        }
    }
    window.Map = function () {
        var iterable = arguments[0], keys = [], values = [], self;
        if (!(this instanceof Map)) throw new TypeError('Constructor requires \'new\'');
        self = this;
        if (iterable != null) {
            if(!isArray(iterable)) {
                throw new TypeError('undefined is not a function');
            } else {
                for(var i=0; i < iterable.length; i++) {
                    if(!isArray(iterable[i])) {
                        throw new TypeError('Iterator value 1 is not an entry object')
                        return self;
                    }
                }
                for(var i=0; i < iterable.length; i++) {
                    keys.push(iterable[i][0]);
                    values.push(iterable[i][1]);
                }
            }
        }

        self.__mapKeysData__ = keys;
        self.__mapValuesData__ = values
        return self;
    }

    Map.prototype.clear = function () {
        if (!this.__mapKeysData__.length) return;
        this.__mapKeysData__ = 0;
        this.__mapValuesData__ = 0;
        this.__mapValuesData__ = {};
    };
    Map.prototype.delete = function (key) {
        var index = eIndexOf.call(this.__mapKeysData__, key);
        if (index === -1) return false;
        this.__mapKeysData__.splice(index, 1);
        this.__mapValuesData__.splice(index, 1);
        return true;
    };
    Map.prototype.entries = function () {
        var Entries = [];
        for(var i = 0; i < this.__mapKeysData__.length; i++) {
            Entries.push([this.__mapKeysData__[i], this.__mapValuesData__[i]]);
        }
        return Entries;
    };
    Map.prototype.forEach = function (cb) {
        var thisArg = arguments[1];
        for(var i = 0; i < this.__mapKeysData__.length; i++) {
            Function.prototype.call.call(cb, thisArg, this.__mapValuesData__[i],
                this.__mapKeysData__[i], this);
        }
    };
    Map.prototype.get = function (key) {
        var index = eIndexOf.call(this.__mapKeysData__, key);
        if (index === -1) return;
        return this.__mapValuesData__[index];
    };
    Map.prototype.has = function (key) {
        return eIndexOf.call(this.__mapKeysData__, key) !== -1;
    };
    Map.prototype.keys = function () { return this.__mapKeysData__  };
    Map.prototype.set = function (key, value) {
        var index = eIndexOf.call(this.__mapKeysData__, key);
        if (index === -1) {
            index = this.__mapKeysData__.push(key) - 1;
        }
        this.__mapValuesData__[index] = value;
        return this;
    };
    Map.prototype.size = function () { return this.__mapKeysData__.length };
    Map.prototype.values = function () { return this.__mapValuesData__ };
    Map.prototype.toString = function () { return '[object Map]' };

}



// WEBPACK FOOTER //
// ./src/tools/polyfill.js